export default {
  privacy: {
    lastUpdated: '最後更新時間：2022年3月18日',
    companyName: 'Linktivity Inc.',
    title: '隱私政策',
    personalInfoProtectionPolicy: '個人資料保護政策',
    personalInfoProtectionDescription:
      'Linktivity Inc.(以下稱「公司」)透過預訂網站LINKTIVITY等收集使用者的個人資料。公司認為保護使用者個人資料以使使用者能夠安心便利地進行預訂是極其重要的，公司遵守以下規定進行個人資料處理。',
    customerDataManager: '使用者數據管理員',
    companyAddress: '日本東京都千代田區內幸町2-1-6 日比谷公園前19樓',
    acquisition: '採集',
    acquisitionDescription:
      '公司僅在法律要求時獲得使用者同意後，為達到規定的使用目的而採集最少必要的個人資料。',
    usage: '使用',
    usageDescription:
      '公司僅將從使用者處採集的個人資料用於達到規定的使用目的。',
    storage: '存儲和保留',
    storageDescription:
      '公司謹慎關注系統安全，防止從使用者處採集的個人資料向外部洩露，進行個人資料的存儲和保留。',
    destruction: '銷毀和刪除',
    destructionDescription:
      '公司對不再需要使用的個人數據從不再需要的時點起毫不遲延地進行銷毀。',
    customerInquiry: '對使用者查詢的回應',
    customerInquiryDescription:
      '公司根據相關法律法規對使用者關於持有個人數據的使用目的通知請求、公開請求、更正/增加/刪除請求、使用中止/刪除請求以及第三方提供中止請求進行對應。',
    safetyMeasures: '安全管理措施',
    safetyMeasuresDescription:
      '公司透過教育確保所有與LINKTIVITY服務相關的員工理解個人資料的重要性，並採取必要且適當的措施進行個人資料保護。',
    tableOfContents: '目錄',
    policy1: {
      title: '公司採集的個人資料及使用目的',
      description:
        '公司為以下規定的使用目的採集和使用使用者的地址、姓名、出生日期、聯繫方式、電子郵件地址、護照號碼等個人資料。公司不在未獲使用者同意的情況下採集敏感個人資料。在採集使用者個人資料時，如個人資料的使用目的未公開，公司應向使用者通知或公開該採集的個人資料的使用目的。公司不在未獲父母同意的情況下採集13歲以下兒童的個人資料。在提供13歲以下兒童的個人資料時，公司將其視為已獲得父母同意，但如明確得知未獲同意，公司除了與父母聯繫及相關目的外，不使用該個人資料。',
      serviceUsage: {
        title: 'LINKTIVITY服務使用(會員註冊等)',
        description: '為使用LINKTIVITY服務，使用者個人資料在公司內部共享。',
        legalBasis: '為提供使用者要求的服務和功能而必需。'
      },
      ticketPurchase: {
        title: '車票購買申請',
        infoItems:
          '公司在處理來自產品提供商的車票購買申請時，採集使用者的姓名、支付資訊、護照號碼以及使用者的健康狀況相關資訊，包括健康狀態和病史。',
        purpose:
          '公司採集和使用使用者個人資料以驗證來自產品提供商的車票購買資格並處理車票及相關費用的支付。為實現這一目的，公司可向產品提供商、運輸公司、支付處理器和其他服務提供商(包括海外提供商)提供使用者個人資料。',
        legalBasis: '為提供使用者要求的服務和功能而必需。'
      },
      newsletter: {
        title: '發送新聞通訊(電子郵件雜誌等)及使用者通信',
        legalBasis: '基於使用者同意採集。'
      },
      advertising: {
        title: '透過社交媒體和廣告分發平台進行的廣告',
        legalBasis: '基於使用者同意採集。'
      },
      survey: {
        title: '問卷調查參與請求',
        legalBasis: '基於使用者同意採集，用於改進預訂網站、產品和服務。'
      },
      analysis: {
        title: '使用者資訊分析和管理',
        legalBasis:
          '為透過改進預訂網站、產品和服務來追求和保護使用者的正當利益而必需。'
      },
      fraudDetection: {
        title: '信用卡等欺詐使用檢測',
        legalBasis: '為確保使用者信用卡的安全並追求使用者的正當利益而必需。'
      }
    },
    policy2: {
      title: '個人數據的第三方提供',
      description: '除以下情況外，公司不向第三方提供從使用者處採集的個人數據。',
      case1:
        '當使用者透過本隱私政策或其他方式事先同意向第三方(包括產品提供商、海外旅行社、社交媒體提供商、廣告分發服務公司等)提供個人數據時。',
      case2: '當在達到規定使用目的所必需的範圍內將個人數據處理外包給第三方時。',
      case3: '當法律要求提供時。',
      case4: '當為保護人類生命、身體或財產而必需，且難以獲得使用者同意時。',
      case5:
        '當為改進公共衛生或促進兒童健全發展而特別必需，且難以獲得使用者同意時。',
      case6:
        '當政府或地方政府為實施法律規定的事務而需要合作，且獲得使用者同意可能會阻礙該事務的執行時。'
    },

    policy3: {
      title: '個人數據處理的委託',
      description:
        '當公司在達到規定使用目的所必需的範圍內將使用者個人數據處理委託給第三方時，公司對受委託的機構進行必要且適當的監督。如受委託的機構進一步委託給其他機構，公司直接或間接監督受委託的機構是否對再委託機構進行了必要且適當的監督。再委託機構的進一步委託情況也應如此。'
    },
    policy4: {
      title: 'Cookie資訊等採集',
      cookie: {
        title: 'Cookie',
        description1:
          'Cookie是存儲在使用者硬碟上包含有關使用者資訊的數據文件。公司不使用Cookie來識別個人。Cookie是會話Cookie，當使用者關閉瀏覽器時不會被保留。Cookie用於改進使用者服務、自訂網站、測量廣告效果等目的。',
        description2:
          '公司將Cookie作為統計數據進行分析，以識別使用者的興趣和關注點並加以利用。Cookie也用於防止未授權訪問。',
        description3:
          '使用者可根據偏好禁用Cookie，但這樣做會導致使用者無法在LINKTIVITY進行預訂。'
      },
      logFile: {
        title: '日誌文件',
        description1:
          '公司自動採集某些資訊並將其保存到日誌文件。這些特定資訊包括IP(網際網路協議)地址、瀏覽器類型、ISP(網際網路服務提供商)名稱、參考/退出頁面、作業系統及日期/時間戳。公司利用這些資訊監控未授權訪問、進行使用者趨勢分析、網站管理以及使用者在網站上的行為追蹤。',
        description2:
          '但是，公司以不能識別特定個人的方式使用這些資訊，不會將採集的資訊用於上述目的以外的任何目的。'
      },
      webBeacon: {
        title: '網路信標',
        description:
          '公司使用網路信標用於訪問分析和附屬計畫。公司不使用網路信標進行上述目的以外的任何目的或用於識別特定個人。'
      },
      statisticalAnalysis: {
        title: '統計分析',
        description1:
          '公司使用第三方訪問分析工具來識別哪些網站和服務受歡迎，並記錄使用者在LINKTIVITY網站內訪問的頁面和頁面歷史。',
        description2:
          '公司使用這些數據為在特定領域表示出興趣的使用者在LINKTIVITY內提供符合其興趣的內容和廣告。',
        description3:
          '公司也可採集不識別個人的統計資訊。此外，公司採集的Cookie資訊和其他方採集的Cookie資訊也可在第三方訪問分析工具平台上由雙方查看。'
      }
    },
    policy5: {
      title: '匿名處理資訊的處理',
      creation: {
        title: '匿名處理資訊的建立',
        description1:
          '公司在建立匿名處理資訊時採取以下措施。匿名處理資訊是指根據法律要求以無法識別特定個人的方式處理個人資料而獲得的個人相關資訊，使得原個人資料無法恢復。',
        description2:
          '① 按照法律規定的標準進行適當處理 ② 按照法律規定的標準實施安全管理措施以防止刪除的資訊和處理方法相關資訊的洩露 ③ 公開包含在建立的匿名處理資訊中的個人相關資訊的項目 ④ 不進行識別用於建立匿名處理資訊的個人資料所涉原人的行為'
      },
      provision: {
        title: '匿名處理資訊的提供',
        description:
          '當向第三方提供匿名處理資訊時，公司公開包含在匿名處理資訊中的個人相關資訊的項目和提供方式，並向接收者明示所提供的資訊是匿名處理資訊。'
      },
      disclosure: {
        title: '關於匿名處理資訊的公開',
        creationSubtitle: '匿名處理資訊的建立',
        creationDescription:
          '關於公司持有的以下使用者個人資料，公司在採取適當措施防止識別特定個人且確保原個人資料無法恢復的基礎上，持續建立匿名處理資訊。',
        itemsTitle: '包含在匿名處理資訊中的個人相關資訊的項目',
        itemsDescription:
          '平台服務提供相關採集的資訊：購買日期、參與日期、憑證語言、銷售金額範圍、參與者數量、預訂狀態(已確認或已取消)、供應商位置和地區資訊、旅行社位置國家。',
        thirdPartyTitle: '匿名處理資訊的第三方提供',
        thirdPartyDescription:
          '關於公司建立或持有的匿名處理資訊，公司在明示該資訊是匿名處理資訊的基礎上持續向第三方提供。',
        provisionMethod:
          '透過電子通信手段(電子郵件、伺服器上傳、API整合等)或物理媒體(如DVD)傳送密碼保護的電子文件。'
      }
    },
    policy6: {
      title: '個人數據的安全管理措施',
      description1:
        '公司採取組織、技術和物理安全管理措施以防止個人數據的洩露、盜用、濫用、未授權訪問、竄改和破壞。公司存儲個人數據的伺服器訪問僅限於擁有ID和密碼訪問權限的授權員工，其中某些個人數據的訪問權限僅授予數據管理所必需的最少員工。',
      description2:
        '此外，包含信用卡資訊的個人數據存儲在分散於多個數據中心的安全環境中。公司對與預訂交易相關的所有頁面使用安全套接層(SSL)加密。使用SSL相容瀏覽器可維護透過網際網路傳輸的個人數據和信用卡資訊的機密性。',
      description3:
        '處理使用者個人數據的公司員工在離開終端時使用密碼保護的螢幕保護程式。',
      description4:
        '此外，公司對某些部門每月進行一次、公司範圍內每年至少進行兩次關於個人資料重要性等的教育培訓。公司還保留這些培訓的記錄。'
    },
    policy7: {
      title: '關於個人數據處理的使用者權利',
      description:
        '根據2016年4月27日的歐盟通用數據保護條例(GDPR) 2016/679，使用者在個人數據處理方面具有以下權利：',
      right1: '訪問權',
      right2: '更正權',
      right3: '刪除權(被遺忘權)和限制處理權',
      right4: '數據可攜性權',
      right5: '異議權',
      right6: '不受基於分析的自動化決策約束的權利。'
    },
    policy8: {
      title: '關於公開、更正、中止使用等請求',
      description1:
        '公司透過下文第11節所述的聯繫方式對使用者關於持有個人數據的使用目的通知請求、公開請求、更正/增加/刪除請求、使用中止/刪除請求以及第三方提供中止請求(以下統稱"公開等請求")進行對應。',
      description2:
        '此外，公司透過使用者的賬戶頁面對使用者更改和確認會員資訊以及中止電子郵件雜誌配送等的請求進行對應。'
    },
    policy9: {
      title: '關於外部鏈接',
      description:
        'LINKTIVITY主頁包含指向其他網站的鏈接。本隱私政策僅適用於透過LINKTIVITY主頁採集的資訊，公司對其他網站的隱私政策或內容不承擔責任。使用者應閱讀所鏈接網站的隱私政策並確認其個人資料如何被處理。'
    },
    policy10: {
      title: '隱私政策的更改',
      description:
        '公司在LINKTIVITY主頁上發佈本隱私政策，使使用者能夠始終了解公司採集什麼個人資料、出於什麼目的採集以及如何使用。隱私政策的任何更改也會在LINKTIVITY主頁上發佈並向使用者公開。'
    },
    policy11: {
      title: '聯繫方式',
      description1:
        '關於公司隱私政策、公司個人資料保護措施、採集和使用使用者個人資料或提出公開等請求的任何問題，請使用下面的聯繫表。代表將在5個工作日內回覆。',
      company: 'Linktivity Inc.',
      address: '日本東京都千代田區內幸町2-1-6 日比谷公園前19樓',
      dpoContact: '數據保護官聯繫方式: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '採集的個人資料',
      specificPurpose: '具體的使用目的',
      legalBasis: '法律依據：',
      provisionMethod: '提供方式'
    }
  }
};
